<template>
    <el-dialog :visible.sync="openDialog" width="calc(100% - 100px)" @closed="closed" :title="title" :close-on-click-modal="false">
        <el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle">
            <el-table-column prop="rowNo" width="50" label="行号" fixed align="left"> </el-table-column>
            <el-table-column prop="wzCode" label="物料编码" :show-overflow-tooltip="true" width="100"> </el-table-column>
            <el-table-column prop="wzName" label="物料名称" :show-overflow-tooltip="true" width="120" > </el-table-column>
            <el-table-column prop="wzClassCode" label="物资分类" :show-overflow-tooltip="true"> </el-table-column>
            <el-table-column prop="wzSspce" label="规格" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="wzModel" label="型号" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="unit" label="计量单位" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="num" label="需求数量" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="xqDate" label="需求日期" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="bcExplain" label="行备注" :show-overflow-tooltip="true"> </el-table-column>
            <el-table-column label="附件" width="95">
                <template slot-scope="scope">
                    <el-tag v-if="!scope.row.src" type="info">无附件
                    </el-tag>
                    <el-link v-if="scope.row.src" :underline="false" :href="baseURL+scope.row.src" target="_blank">
                        <el-tag type="success">查看附件</el-tag>
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column prop="isConcatTax" label="是否含税" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="taxRate" label="税率" :show-overflow-tooltip="true" :formatter="formatTaxRate" width="120"> </el-table-column>
          <el-table-column label="操作" width="90" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" :disabled="disGoodsIds[scope.row.id]" @click="selectRow(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>
</template>
<script>
import { inquiryDetailList } from '@/api/srm/inquiryDetail.js'
export default {
    data(){
        return {
            disGoodsIds:{},
            title:'添加物料',
            openDialog:false,
            count: 0,
            quertInfo: {
                page: 1, //当前页码
                limit: 1000, //当前每页显示的数量
                objMap:{
                    orderId: '',
                }
            },
            tableData:[],
        }
    },
    methods:{
        onPagination: function (val) {
            this.quertInfo.page = val.page;
            this.quertInfo.limit = val.limit;
            this.getList();
        },
        async getList(hId) {
            let _this = this;
            _this.quertInfo.objMap.orderId= hId
            const {
                data: res
            } = await inquiryDetailList(_this.quertInfo)
            if (res.code == 0) {
                _this.tableData = res.data;
                _this.tableData.forEach((good,goodIndex)=>{
                    good['rowNo'] = goodIndex+1;
                })
            }
        },
        selectRow(row){
            this.$emit('callback', {type:'add',data:row});
        },
        onSearch(){
            this.quertInfo.page = 1;
            this.getList()
        },
        formatTaxRate: function(row) {
            if(row.taxRate || row.taxRate == 0){
                return row.taxRate+'%';
            }else{
                return ''
            }

        },
        closed(){
            this.tableData = [];
            this.disGoodsIds = {};
            this.quertInfo.objMap.orderId= ''
        },
    }
}
</script>

<style lang="sass" scoped>

</style>

